import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import SimpleRecipeModel from '../../models/SimpleRecipe';

interface MenuState {
  recipes: SimpleRecipeModel[];
  tempRecipes: SimpleRecipeModel[];
}

const initialState: MenuState = {
  recipes: [],
  tempRecipes: [],
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuSimpleRecipes(state, action: PayloadAction<SimpleRecipeModel[]>) {
      state.recipes = action.payload;
      state.tempRecipes = [...action.payload];
    },
    updateStateSimpleRecipe(state, action: PayloadAction<SimpleRecipeModel>) {
      const index = state.recipes.findIndex(recipe => recipe.id === action.payload.id);
      if (index !== -1) {
        state.recipes[index] = action.payload;
      }
    },
    updateTempRecipeOrder(state, action: PayloadAction<SimpleRecipeModel[]>) {
      state.tempRecipes = action.payload;
    },
    confirmRecipeOrder(state) {
      state.recipes = [...state.tempRecipes];
    },
    resetTempRecipes(state) {
      state.tempRecipes = [...state.recipes];
    },
    clearMenuSimpleRecipes(state) {
      state.recipes = [];
      state.tempRecipes = [];
    }
  }
});

export const {
  setMenuSimpleRecipes,
  updateStateSimpleRecipe,
  updateTempRecipeOrder,
  confirmRecipeOrder,
  resetTempRecipes,
  clearMenuSimpleRecipes
} = menuSlice.actions;

export default menuSlice.reducer;
